import '@admin/fe2app-sdk';
import { STORAGE_CHANNEL_KEY, STORAGE_PLATFORM_KEY, STORAGE_TOKEN_KEY } from '@local-utils/const';
import { setHeaders } from '@local-composable/request';
import queryString from 'query-string';
import { defaultEnvOptions } from './init.js';
import { DownloadUrl } from '@local-utils/const';
import { useClipboard } from '@vueuse/core';
import { parseUA } from './browser.js';
import isMobile from 'is-mobile';

export function isInApp() {
  if (!window.mmc.client.isAPP()) return false;

  const app = ['ljds', 'ydk'];
  return app.some((val) => window.mmc.client.is(val));
}

export const isApp = /*#__PURE__*/ isInApp();

export function goAppModule({ action = 110, global_type, func_type, data, callBack, config }) {
  const { closeWindow, needRefresh, needCallback } = Object.assign(
    {
      closeWindow: false,
      needRefresh: true,
      needCallback: true,
    },
    config,
  );

  // todo window.mmc.client.goto的callBack测试过不执行，改成这种偶尔执行。。。。
  // window.MMCWKEventWeb.eventController.addEvent('cb_MMCGoto', (params) => {
  //   callBack(params);
  // });

  window.mmc.client.goto(
    {
      params: {
        action,
        actioncontent: {
          global_type: global_type,
          func_type: func_type,
          data: data || {},
        },
        closeWindow,
        needRefresh,
        needCallback,
      },
    },
    callBack,
    // 'cb_MMCGoto',
  );

  // todo 上面的callBack有时候不触发，暂时解决方案
  setTimeout(() => {
    if (callBack && typeof callBack === 'function') {
      callBack();
    }
  }, 1500);
}

/**
 * 在app内打开外部浏览器
 * @param link
 */
export function openExternalBrowser(link) {
  console.log(link, '===========');

  goAppModule({
    action: 103,
    global_type: link,
  });
}

export function getAppUserInfo() {
  return window.mmc.user.getInfo() || {};
}

export function getAppDeviceInfo() {
  return window.mmc.client.getInfo() || {};
}

export async function appPromiseInit() {
  if (window.mmc.afterReady) return;
  if (!window.mmc.afterReady) {
    window.mmc.init();
  }
  return new Promise((resolve) => {
    window.mmc.ready(resolve);
  });
}

/**
 * 获取用户信息，支持重试机制
 * @param {number} maxRetries 最大重试次数
 * @param {number} retryDelay 重试延迟时间(ms)
 * @returns {Promise<Object>} 用户信息
 */
async function getUserInfoWithRetry(maxRetries = 3, retryDelay = 500) {
  for (let i = 0; i < maxRetries; i++) {
    try {
      const userInfo = getAppUserInfo();

      // 如果获取到token，直接返回
      if (userInfo.token) {
        return userInfo;
      }

      // 如果没有token且不是最后一次重试，等待后重试
      if (i < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    } catch (error) {
      if (i < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  // 所有重试都失败，返回空对象
  return {};
}

export async function appEnvInit(options) {
  options = {
    ...defaultEnvOptions,
    ...options,
  };

  await appPromiseInit();

  // 使用重试机制获取用户信息
  const userInfo = await getUserInfoWithRetry();
  const deviceInfo = getAppDeviceInfo();

  goAppModule({
    global_type: 'web',
    func_type: options.appTitleBar ? 'set_normal_titlebar' : 'set_transparent_titlebar',
  });

  if (!userInfo.token) {
    window.mmc.user.login(() => {
      location.reload();
    });
    return;
  }

  setHeaders('Lang', deviceInfo.lang);
  setHeaders('system', 'app_web');

  // 2023.08.30跟大河确认过的逻辑
  // app内channel参数获取的优先级：路由query > 客户端 > 项目默认
  const query = queryString.parse(location.search);
  const channel = query.channel || userInfo.channel || import.meta.env.VITE_APP_DEFAULT_CHANNEL;
  if (channel) {
    localStorage.setItem(STORAGE_CHANNEL_KEY, channel);
  }

  // Token
  localStorage.setItem(STORAGE_TOKEN_KEY, userInfo.token);

  const platform = options.platform || userInfo.platform;
  // Platform
  localStorage.setItem(STORAGE_PLATFORM_KEY, platform);

  // version
  localStorage.setItem('app_version', userInfo.version);
}

export function callNativeFn(name, data) {
  return new Promise((resolve) => {
    window.mmc.callClientFunction(name, data, (cb_data) => {
      if (!cb_data) {
        resolve(cb_data);
        return;
      }

      try {
        resolve(JSON.parse(cb_data));
      } catch (e) {
        // 不确定客户端是不是返回的json，后续有需要就改改
        console.error(e);
        resolve(e);
      }
    });
  });
}

// 项目页面只展示一次绑定邮箱弹窗方法, 该逻辑下架，直接 callback
export async function onceOpenAppBindEmail(callback) {
  callback();
  // if (!isInApp()) {
  //   callback();
  //   return;
  // }
  // const projectName = window.location.pathname.split('/')[2];
  // // 获取本地存储的记录展示过绑定弹窗的页面
  // // 数据结构{用户id: ['页面名字','页面名字','页面名字'], 用户id: ['页面名字','页面名字','页面名字']}
  // const showBindEmailPage = JSON.parse(localStorage.getItem('common_showBindEmailPage')) || {};
  // // 獲取用戶信息
  // let uid = localStorage.getItem('uid');
  // if (!uid) {
  //   const { data, error } = await useRequest({
  //     url: '/v1/user/information',
  //   }).get();
  //   if (error.value) return;
  //   const uid = data.value.uid;
  //   localStorage.setItem('uid', uid);
  // }
  // if (!Object.keys(showBindEmailPage).includes(uid)) {
  //   showBindEmailPage[uid] = [projectName];
  //   localStorage.setItem('common_showBindEmailPage', JSON.stringify(showBindEmailPage));
  //   openAppBindEmail(callback);
  // } else if (!showBindEmailPage[uid].includes(projectName)) {
  //   showBindEmailPage[uid].push(projectName);
  //   localStorage.setItem('common_showBindEmailPage', JSON.stringify(showBindEmailPage));
  //   openAppBindEmail(callback);
  // } else {
  //   callback();
  // }
}

// 打开绑定邮箱弹窗方法, 该逻辑下架，直接 callback
export function openAppBindEmail(callback) {
  callback();
  // if (!isInApp()) {
  //   callback();
  //   return;
  // }
  // try {
  //   goAppModule({
  //     global_type: 'abPath',
  //     func_type: 'loginAlert',
  //     config: {
  //       needCallback: true,
  //       closeWindow: false,
  //     },
  //     callBack: () => {
  //       callback();
  //     },
  //   });
  // } catch (err) {
  //   callback();
  // }
}

export const downloadApp = (type = null) => {
  let isIos;
  if (type) {
    isIos = Boolean(type === 'ios');
  } else {
    const res = parseUA();
    isIos = res.ios || res.macos;
  }

  if (isIos) {
    window.location.href = DownloadUrl.ios;
  } else {
    window.location.href = DownloadUrl.android;
  }
};

function isSafariBrowser() {
  const uaInfo = parseUA();
  const userAgent = navigator.userAgent;
  const isIpadOsSafari = uaInfo.macos && navigator.maxTouchPoints > 1;
  const isAppleMobileDevice = uaInfo.ios || isIpadOsSafari;
  const hasSafariSignature = userAgent.includes('Safari') && userAgent.includes('Version/');
  const excludedBrowserPattern =
    /MQQBrowser|QQBrowser|QQ\/|CriOS|Chrome|Chromium|FxiOS|Firefox|EdgiOS|Edg|OPiOS|OPR|OPT\/|UCBrowser|MicroMessenger/i;

  return isAppleMobileDevice && hasSafariSignature && !excludedBrowserPattern.test(userAgent);
}

export function openApp(
  type,
  shouldCopyToken = true,
  scheme = 'seeronnet://main/home',
  options = {},
) {
  const { onOpenFailed } = options;
  // 从URL获取token并设置到localStorage，然后清除URL上的token参数
  const query = queryString.parse(location.search);
  if (query.token) {
    localStorage.setItem(STORAGE_TOKEN_KEY, query.token);
    // 清除URL上的token参数
    const { url } = queryString.parseUrl(location.href);
    const otherQuery = { ...query };
    delete otherQuery.token;
    const newUrl = queryString.stringifyUrl({
      url,
      query: otherQuery,
    });
    window.history.replaceState(null, '', newUrl);
  }

  // 只有在 shouldCopyToken 为 true 时才复制 token（避免覆盖已复制的内容），且只在移动端复制
  if (shouldCopyToken && localStorage.getItem('token') && isMobile()) {
    const { copy } = useClipboard({
      legacy: true,
    });
    const copyToken = `SEER#TOKEN=${localStorage.getItem('token')}`;
    copy(copyToken);
  }

  if (isSafariBrowser()) {
    downloadApp('ios');
    return;
  }

  // 1. 创建隐藏的a标签
  const link = document.createElement('a');
  link.href = scheme;
  link.style.display = 'none';

  let appLaunched = false;

  // 3. 添加页面模糊事件监听（App打开成功会触发）
  const blurHandler = () => {
    appLaunched = true;
  };
  window.addEventListener('blur', blurHandler);

  // 4. 必须将元素添加到DOM才能工作
  document.body.appendChild(link);

  // 5. 模拟点击
  link.click();

  // 6. 设置超时检查
  setTimeout(async () => {
    // 移除监听和元素
    window.removeEventListener('blur', blurHandler);
    document.body.removeChild(link);

    // 检查是否成功打开App
    if (!appLaunched && document.hasFocus()) {
      // 如果仍在当前页面，优先执行失败回调；未配置时走下载页
      if (onOpenFailed && typeof onOpenFailed === 'function') {
        try {
          await onOpenFailed();
        } catch (error) {
          console.error('openApp failed callback error:', error);
        }
      } else {
        downloadApp(type);
      }
    }
  }, 500);
}
